import { createReducer, on } from '@ngrx/store';
import * as AccountInfoActions from '../../account-info-header/actions/account-info.actions';
import { TableComponentState } from '../../shared/types/TableComponentState';
import { TransactionsTableColumn, TransactionsTableSavedTemplateColumn } from '../../shared/types/TransactionTableColumn';
import { ConfirmationPageActions, ReviewPageActions, StandingAuthorizationsTableActions, TransactionFormActions, TransactionsTableActions, WireActions } from '../actions';
import { ViewPageActions } from '../../transaction-view/actions';
import { TransactionFormServiceError } from '../models/form/TransactionForm';
import { ApiEndpointType, transactionstableTabName } from '../../shared/utilities/Constants';

export const transactionsTableStateKey = 'transactionsTableState';

export interface State extends TableComponentState {
  currentTransaction?: TransactionsTableColumn;
  currentTemplate?: string;
  currentTab: transactionstableTabName | '';
  deleteTemplateError: TransactionFormServiceError;
}

export const initialTransactionsTableState: State = {
  loading: false,
  error: '',
  hasError: false,
  gridReady: false,
  isInitialLoad: true,
  printClicked: false,
  currentTransaction: {
    Type: '',
    Direction: 'Outgoing',
    'To/From': '',
    'Transaction date': '',
    Frequency: '',
    Amount: '',
    IsEditable: false,
    IsCancelable: false,
    IsActiveRecurring: false,
    isBundled: false
  },
  currentTemplate: '',
  currentTab: '',
  hasEmptyResponse: false,
  deleteTemplateError: {
    status: 0,
    url: '',
    name: '',
    message: '',
    correlationId: '',
    hasError: false
  },
  cancelLinkClicked: false
};

export const transactionsTableStateReducer = createReducer(
  initialTransactionsTableState,
  on(TransactionsTableActions.gridReady, (state, action) => {
    return {
      ...state,
      gridReady: action.gridReady,
      currentTab: action.tab
    };
  }),
  on(
    AccountInfoActions.loadTransactions,
    TransactionsTableActions.refresh,
    StandingAuthorizationsTableActions.refresh,
    ConfirmationPageActions.viewTransactionStatusClicked,
    ConfirmationPageActions.createAnotherRequestClicked,
    WireActions.callWireTemplatesGetListTable,
    (state) => {
      return {
        ...state,
        loading: true,
        error: '',
        hasError: false,
      };
    }
  ),
  on(TransactionsTableActions.cancelTransaction, (state) => {
    return {
      ...state,
      loading: true,
      error: '',
      hasError: false,
      cancelLinkClicked: true
    }
  }),
  on(AccountInfoActions.updateSubAccount, (state) => {
    return {
      ...state
    }
  }),
  on(AccountInfoActions.loadTransactionsSuccess, (state) => {
    return {
      ...state,
      loading: false,
      hasError: false,
      isInitialLoad: false,
      cancelLinkClicked: false
    };
  }),
  on(AccountInfoActions.loadTransactionsFailure, (state, err) => {
    return {
      ...state,
      loading: false,
      error: err.message,
      hasError: true,
      isInitialLoad: false,
      cancelLinkClicked: false
    };
  }),
  on(AccountInfoActions.loadAccountInfoFailure, (state, { errorMsg }) => {
    return {
      ...state,
      loading: false,
      error: errorMsg,
      hasError: true,
    };
  }),
  on(StandingAuthorizationsTableActions.printClicked, (state) => {
    return {
      ...state,
      printClicked: false
    };
  }),
  on(TransactionsTableActions.printClicked, (state) => {
    return {
      ...state,
      printClicked: true
    };
  }),
  on(TransactionsTableActions.setCurrentViewedTransaction, (state, response) => {
    return {
      ...state,
      currentTransaction: response.transaction
    }
  }),
  on(TransactionFormActions.cancelClicked,
    ViewPageActions.backButtonClicked,
    ReviewPageActions.cancelClicked,
    ViewPageActions.backButtonClickedFromMsv,
    (state) => {
      return {
        ...state,
        currentTransaction: initialTransactionsTableState.currentTransaction
      }
    }),
  on(TransactionsTableActions.currentTabUpdated, (state, { currentTab }) => {
    return {
      ...state,
      currentTab: currentTab,
      hasError: false,
      deleteTemplateError: {
        status: 0,
        url: '',
        name: '',
        message: '',
        correlationId: '',
        hasError: false
      }
    }
  }),
  on(TransactionsTableActions.hasEmptyResponse, (state) => {
    return {
      ...state,
      hasEmptyResponse: true,
    }
  }),
  on(WireActions.callWireTemplatesGetListTableSuccessful, (state) => {
    return {
      ...state,
      loading: false,
    }
  }),
  on(TransactionsTableActions.cancelTransactionFailure, (state) => {
    return {
      ...state,
      loading: false,
      cancelLinkClicked: false
    }
  }),
  on(WireActions.callWireTemplatesGetListTableFailed, (state, err) => {
    return {
      ...state,
      loading: false,
      error: err.message,
      hasError: true,
    };
  }),
  on(TransactionsTableActions.setCurrentViewedTemplate, (state, response) => {
    return {
      ...state,
      currentTemplate: response.template?.draftId ?? ''
    }
  }),
  on(TransactionsTableActions.deleteTemplateFailure, (state, err) => {
    return {
      ...state,
      loading: false,
      hasError: true,
      deleteTemplateError: {
        ...state.deleteTemplateError,
        status: err.status,
        url: err.url,
        name: ApiEndpointType.wireTemplate,
        message: err.message,
        hasError: !err.ok
      }
    }
  }),
  on(TransactionsTableActions.deleteTemplate, (state, err) => {
    return {
      ...state,
      hasError: false,
      deleteTemplateError: {
        status: 0,
        url: '',
        name: '',
        message: '',
        correlationId: '',
        hasError: false
      }
    }
  }),
  on(TransactionFormActions.loadReviewPage, (state) => {
    return {
      ...state,
      currentTab: "" as transactionstableTabName
    }
  }),
);